import React from 'react';
import {Modal} from 'react-bootstrap';
import {ComponentUtils, DetailActions, SwEmbeddedDetail, SwForm, notification} from 'simplifyworks-core-ui';
import i18n from 'i18next';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {getElementAfter} from '../../utils';

const GrantAnonymousAccessModal = (props) => {
	return (
		<>
			<Modal
				show={props.show}
				onHide={() => props.close()}
				size={'xl'}
			>
				<Modal.Header closeButton>
					<Modal.Title style={{width: 'auto'}}>
						{i18n.t('foedus-grant-anonymous-access')}
					</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					<SwEmbeddedDetail
						name='grant-anonymous-access'
						rest='/api/foedus/organ-offer/grant-anonymous-access'
						restId='new'
						tabName=''
						createButtonLabelKey='foedus-grant-anonymous-access'
						newCallback={(actionResult, id, errorResponse) => {
							if (!errorResponse) {
								props.close();

								props.entryFormKeys.forEach(formKey => {
									props.actions.detail.load(props.detailPath, formKey);
								});

								notification.showMessage({
									level: 'success',
									title: i18n.t('foedus-grant-anonymous-access-success-title'),
									message: i18n.t(
										'foedus-grant-anonymous-access-success-message',
										{
											emails: props?.grantAnonymousAccessFormData?.emails
										}
									)
								});

								return true;
							}
						}}
					>
						<SwForm
							name='grant-anonymous-access'
							rest=''
							labelKey='grant-anonymous-access'
							initialValue={{
								entryId: props?.entryId
							}}
							valueChanged={(data, property, value, callback) => {
								callback(data);
							}}
						>
							<SwForm.Section>
								<SwForm.Strings
									size={12}
									property='emails'
									name='emails'
									labelKey='foedus-emails'
									itemValidations='required;email'
									displayType='inlineInput'
								/>
							</SwForm.Section>
						</SwForm>
					</SwEmbeddedDetail>
				</Modal.Body>
			</Modal>
		</>

	);
};

const mapDispatchToProps = (dispatch) => ({
	actions: {
		detail: bindActionCreators(DetailActions, dispatch)
	}
});

const mapStateToProps = (state) => {
	const pathSegments = state?.router?.location?.pathname?.split('/') || [];

	const grantAnonymousAccessFormData = ComponentUtils.getFormData(
		state,
		'/api/foedus/organ-offer/grant-anonymous-access/new',
		'DEFAULT'
	);

	const entryDetailKey = Object.keys(state.details)?.find(key => key.startsWith('/api/ood/entries'));
	const entryFormKeys = entryDetailKey ? Object.keys(state.details?.[entryDetailKey]?.forms) : [];

	return {
		entryId: getElementAfter(pathSegments, 'entries'),
		detailPath: '/api/ood/entries/' + getElementAfter(pathSegments, 'entries'),
		entryFormKeys,
		grantAnonymousAccessFormData
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(GrantAnonymousAccessModal);
